import classNames from 'classnames/bind';
import styles from './FlipCard.module.scss';
import { Card } from '@/components';
import CardSideBack from '../CardSideBack/CardSideBack';
import CardSideFront from '../CardSideFront/CardSideFront';
import { useState } from 'react';

let cx = classNames.bind(styles);

export default function FlipCard({ cardAttr, attributes, innerBlocks, style }) {
	const [isFlipped, setIsFlipped] = useState(false);

  const className = attributes.className?.split(' ') || [];

	function flipCardToBack(e) {
		setIsFlipped(true);
	}

	return (
		<div id={attributes.anchor} className={cx(['flip-outer', attributes.fullHeight && 'full-height'])}>
			<div className={cx(['flip-inner', isFlipped && 'flipped-card'])}>
				<Card className={cx(['card-front', 'card-button', ...className, cardAttr.backgroundImage && 'card-overflow-hidden', cardAttr.reverseTextColor && 'is-dark'])} background={cardAttr.backgroundColor && `bg-${cardAttr.backgroundColor[0]}`} isButton={true} onClick={flipCardToBack} style={style} tabIndex="-1" hidden={isFlipped ? true : false} fullHeight={attributes.fullHeight} outline={cardAttr.hasBorder}>
					<CardSideFront cardAttr={cardAttr} innerBlocks={innerBlocks} />
				</Card>
				<Card className={cx(['card-back', ...className])} background={cardAttr.backgroundColor && `bg-${cardAttr.backgroundColor[0]}`} style={cardAttr.minimumHeight && { minHeight: `${cardAttr.minimumHeight}px` }} hidden={isFlipped ? false : true} outline={cardAttr.hasBorder}>
					<CardSideBack cardAttr={cardAttr} setIsFlipped={setIsFlipped} />
				</Card>
			</div>
		</div>
	);
}
